export default "__VITE_ASSET__DVcE7JV$__"